<kl-basic-info-form
  (closeDialog)="ok()"
  [profileKey]="profileKey"
  [basicInfoFormDetails]="basicInfoFormDetails"
  [isEditBasicDialog]="isEditBasicDialog">
</kl-basic-info-form>
